import { useRef, useState } from "react";
import VerificationInput from "react-verification-input";
import "./index.scss";
import cn from "classnames";

interface IOtpInput {
  onChange: (value: string) => void;
  length: number;
  label?: string;
  hint?: string;
  error?: string;
  likePopup?: boolean;
  readonly?: boolean;
  onBlur?: (value: string) => void;
}

const OtpInput = ({
  label,
  hint,
  error,
  onChange,
  likePopup,
  length = 3,
  readonly,
  onBlur = () => {},
}: IOtpInput) => {
  const verificationInputRef = useRef<HTMLInputElement>(null);
  const [verificationValue, setVerificationValue] = useState<string>("");

  const handleVerificationInputChange = (value: string) => {
    setVerificationValue(value);

    if (length === value.length) {
      onChange(value);
    } else {
      onChange("");
    }
  };

  return (
    <div className={cn("otp", { otp_popup: !!likePopup, readonly })}>
      <div className="otp__container">
        {label && <label className="otp__label">{label}</label>}
        <div className="otp__content">
          <VerificationInput
            ref={verificationInputRef}
            value={verificationValue}
            length={length}
            classNames={{
              container: "otp-input",
              character: "otp-input__character",
              characterSelected: "otp-input__character_selected",
            }}
            placeholder="_"
            autoFocus
            inputProps={{ autoComplete: "one-time-code" }}
            {...(!readonly
              ? {
                  onChange: handleVerificationInputChange,
                  onBlur: () => {
                    onBlur(
                      length === verificationValue.length
                        ? verificationValue
                        : ""
                    );
                  },
                }
              : {})}
          />
          {hint && <span className="input__hint">{hint}</span>}
          {error && <span className="input__error">{error}</span>}
        </div>
      </div>
    </div>
  );
};

export default OtpInput;
